import { __awaiter, __generator } from "tslib";
import { getFileTypeNameFromType } from '@office-start/file-utility';
import { launchApp } from '@office-start/launcher-service';
// Temporary wrapper class on launcherService. Revisit after LauncherService finalized
export function launchAppWrapper(app) {
    return __awaiter(this, void 0, void 0, function () {
        var launchResult, _error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, launchApp({
                            action: 'OpenAppTile',
                            appName: getFileTypeNameFromType(app),
                            url: '',
                        })];
                case 1:
                    launchResult = _a.sent();
                    if (!launchResult.success) {
                        throw Error(launchResult.message);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    _error_1 = _a.sent();
                    // TODO: logging if needed
                    return [2 /*return*/, Promise.resolve({
                            type: "OpenNewDocFailed" /* CreateDocumentResultType.OpenNewDocFailed */,
                        })];
                case 3: return [2 /*return*/, Promise.resolve({ type: "GoToLanding" /* CreateDocumentResultType.GoToLanding */ })];
            }
        });
    });
}
//# sourceMappingURL=launchAppWrapper.js.map